import { Controller } from "@hotwired/stimulus"

// Clones the ribbon track children for infinite scroll animation.
// The CSS animation uses translateX(-50%), which requires exactly 2 copies
// of the content. We render 1 copy in HTML (for SEO) and clone via JS.
export default class extends Controller {
  connect() {
    if (this.element.querySelector("[aria-hidden='true']")) return

    Array.from(this.element.children).forEach(child => {
      const clone = child.cloneNode(true)
      clone.setAttribute("aria-hidden", "true")
      clone.setAttribute("tabindex", "-1")
      this.element.appendChild(clone)
    })
  }
}
